import { classImplementsInterfaces } from "@goodgamestudios/createjs-utilities";
import { VisualVO } from "./VisualVO";

export class TournamentsVO extends VisualVO {
    //TODO später sollen hier genauerer Beschreibungen(Startzeiten etc.) zu den Turnieren stehen
}
classImplementsInterfaces(TournamentsVO, "IInventoryVO");
